/**
 * 割引額を表現
 * 割引のプロセス自体には関与せず、算出された後の「額」のみ扱う
 * それぞれの割引額に意味的なまとまりを与えるのが目的
 * @see https://github.com/Everforth/growthpalette-front/pull/7934#discussion_r1527200685
 *
 * TODO:
 * 将来的には割引額に関する知識はここで管理し、割引額の取得はすべてこのクラスを経由するようにしたい
 */
export class DiscountAmount {
  constructor(
    private readonly discountPrice: DiscountPrice,
    private readonly appliedPoint: AppliedPoint
  ) {}

  get totalDiscountAmount(): number {
    return this.discountPrice.value + this.appliedPoint.value
  }
}

export class DiscountPrice {
  static zero(): DiscountPrice {
    return new DiscountPrice(0)
  }
  static valueOf(amount: number): DiscountPrice {
    return new DiscountPrice(amount)
  }
  private constructor(
    public readonly value: number
  ) {}
}

export class AppliedPoint {
  static zero(): AppliedPoint {
    return new AppliedPoint(0)
  }
  static valueOf(amount: number): AppliedPoint {
    return new AppliedPoint(amount)
  }
  private constructor(
    public readonly value: number
  ) {}
}
